'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useMessageBarTitle_unstable", {
    enumerable: true,
    get: function() {
        return useMessageBarTitle_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactutilities = require("@fluentui/react-utilities");
const _messageBarContext = require("../../contexts/messageBarContext");
const useMessageBarTitle_unstable = (props, ref)=>{
    const { titleId } = (0, _messageBarContext.useMessageBarContext)();
    return {
        components: {
            root: 'span'
        },
        root: _reactutilities.slot.always((0, _reactutilities.getIntrinsicElementProps)('span', {
            ref,
            id: titleId,
            ...props
        }), {
            elementType: 'span'
        })
    };
};
